import { useId } from 'react';
import { Input, Label } from '@design-system';

interface NumberFieldProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  min?: number;
  max?: number;
  step?: number;
  hint?: string;
  name?: string;
}

export function NumberField({ label, value, onChange, min, max, step = 1, hint, name }: NumberFieldProps) {
  const id = useId();

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        name={name}
        type="number"
        inputMode="decimal"
        min={min}
        max={max}
        step={step}
        value={value ?? ''}
        onChange={event =>
          onChange(event.target.value === '' ? null : Number(event.target.value))
        }
        className="bg-white"
      />
      {hint && <p className="text-muted-foreground text-xs">{hint}</p>}
    </div>
  );
}

/** Whether a number entry is present and inside its allowed range. */
export function isWithin(value: number | null, min: number, max: number): value is number {
  return value !== null && Number.isFinite(value) && value >= min && value <= max;
}
